import { ACTIONS_PREFIX } from '../actions/usersWithoutComputersFilters';
import { createFiltersReducer } from '../utils';

const initialFiltersState = {
    officeIds: [],
    pageNumber: 1,
    officeState: 2,
    sortBy: 'userName',
    sortOrder: 'asc',
};

const initialState = {
    currentFilters: {
        ...initialFiltersState
    },
    appliedFilters: {
        ...initialFiltersState
    }
};

const usersWithoutComputersFiltersReducer = createFiltersReducer(ACTIONS_PREFIX, initialState);
export default usersWithoutComputersFiltersReducer;
